import { useQuery } from 'react-query';
import { apiServiceRest } from 'services/api';

import { ICity } from './types';

export const URI = () => '/cities';
export const GET_QUERY_KEY = () => 'get-cities';

export const useGetCities = () => {
  const [apiService] = apiServiceRest<ICity[]>();

  return useQuery(GET_QUERY_KEY(), () => apiService.get(URI()));
};
export default useGetCities;
